// Import the jwt-decode library
import { jwtDecode } from "jwt-decode";

// Function to decode a JWT token and extract the 'userId'
const decodeTokenAndGetUserId = (token) => {
  try {
    const decoded = jwtDecode(token);
    // The 'decoded' object may contain 'userId' if it's in the token payload
    return decoded ? decoded.userId : null;
  } catch (error) {
    // Handle token decoding errors (e.g., invalid tokens)
    console.error('Error decoding token:', error);
    return null;
  }
};

export default decodeTokenAndGetUserId;
